/**
 * 결재 문서 상태 → 화면 표시 한 벌 (2026-10-18 · web 레인 W10-27 · 계획 8.2 · 사용자 결정 D10)
 *
 * 렌즈(Carbon-06 · «상태 표시는 아껴 쓰고, 강조는 가장 급한 하나에»): 강조는 **«내 차례» 한 곳**이다.
 *   - 내 차례 → 칩(`emphasis: 'mine'` · 옅은 파랑 바탕 + 진한 굵은 글 — 주 단추 색이 아니다).
 *   - 나머지(진행 중 · 완료 · 반려 · 회수 · 임시) → 칩 없는 회색 글(`emphasis: 'plain'`).
 * 이름은 결재함의 옛 `statusBadge()` 와 같고, «결재 대기» 만 «내 차례» 다(결재선 칸 글과 같은 말).
 * 결재함(W10-27) · 문서 상세 · 결재 홈(W11b)이 이 표를 함께 쓴다. 옛 statusBadge() · docBadge() 는 W11b 에서 지웠다.
 * (옛 주소 /approval/legacy/* 의 ApprovalDocsPage 는 메뉴 밖이라 그대로 공용 StatusBadge 를 쓴다.)
 */

export interface ApprovalStatusMark {
  label: string;
  emphasis: 'mine' | 'plain';
}

export function approvalStatusMark(status: string, waitingMine: boolean): ApprovalStatusMark {
  if (status === 'IN_PROGRESS') {
    return waitingMine ? { label: '내 차례', emphasis: 'mine' } : { label: '진행 중', emphasis: 'plain' };
  }
  if (status === 'APPROVED') return { label: '완료', emphasis: 'plain' };
  if (status === 'REJECTED') return { label: '반려', emphasis: 'plain' };
  if (status === 'RECALLED') return { label: '회수', emphasis: 'plain' };
  return { label: '임시', emphasis: 'plain' };
}
